import { ApiError } from './api'
import { hasPhrase, t, type StaffKey } from './staffText'

/** The refusal a single sign-on round trip came back with (?sso=CODE), as the
 *  sign-in page shows a refusal; null when there is none. */
export function ssoRefusal(search: string): ApiError | null {
  const code = new URLSearchParams(search).get('sso') ?? ''
  if (!/^[A-Z_]{3,40}$/.test(code)) return null
  const key = `errors.${code}`
  const text = hasPhrase(key) ? t(key as StaffKey, 'en') : t('entry.ssoFailed', 'en')
  return new ApiError(403, code, text)
}

/** The address without ?sso=, so a reload does not show the refusal again. */
export function withoutRefusal(href: string): string {
  const u = new URL(href)
  u.searchParams.delete('sso')
  return u.pathname + (u.search === '?' ? '' : u.search) + u.hash
}

/** Where a sign-in service's button goes; "Keep me signed in" off travels with it. */
export function ssoStart(start: string, remember: boolean): string {
  return remember ? start : `${start}?remember=0`
}
